import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        'https://reportingservice.tcisigorta.com/api/v1/user/login',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            userName: username,
            password,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        const token =
          data.token ?? data.accessToken ?? data.data?.token ?? data.data?.accessToken;
        if (token) {
          localStorage.setItem('authToken', token);
        }
        navigate('/');
      } else {
        Swal.fire({
          title: 'Hata!',
          text: data.message || data.error || 'Giriş başarısız!',
          icon: 'error',
          confirmButtonText: 'Tamam',
        });
      }
    } catch (err) {
      Swal.fire({
        title: 'Hata!',
        text: 'Bir hata oluştu!',
        icon: 'error',
        confirmButtonText: 'Tamam',
      });
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1 className="login-card__title">
          <span className="login-card__title-line">PDF Analiz</span>
        
        </h1>

        <form className="login-form" onSubmit={handleLogin}>
          <input
            type="text"
            className="login-form__input"
            placeholder="Kullanıcı Adı"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
          />
          <input
            type="password"
            className="login-form__input"
            placeholder="Şifre"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
          <button type="submit" className="login-form__submit">
            Giriş Yap
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
